import { newsletterSubscribe } from "./api";
import { pushEvent } from "./analytics";
import { showToast } from './toast';

export function initEmailSignup() {
    // connects email signup form(s) to newsletter api
    
    window.addEventListener('DOMContentLoaded', () => {
        const components = document.querySelectorAll('.cmp-emailsignup')
        components.forEach(component => {
            const form = component.querySelector('form');

            form.addEventListener('submit', (e) => {
                e.preventDefault();
                const email = form.querySelector('input[type="email"]').value;
                newsletterSubscribe(email)
                    .then(() => {
                        component.classList.add('cmp-emailsignup--success');
                        
                        // GTM: Track successful newsletter subscription
                        pushEvent({
                            'event': 'formSubmission',
                            'formID': 'newsletter'
                        });
                    })
                    .catch(e => {
                        console.error('error signing up for newsletter', e);
                        showToast('Sorry, there was a problem adding your email address', 'error');
                    });
            });
        });
    });
}